import "../App.css";
import "../general.css";
import "../queries.css";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import z from "zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";
import config from "../config";
import { toast } from "react-hot-toast";
import InfoPopup from "../components/InfoPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Seo from "../components/SEO"
import { useFacebookPageView } from "../hook/useFacebookPageView";

const formSchema = z.object({
  name: z
    .string({ required_error: "Name is required" })
    .min(3, "Name must be at least 3 character."),
  companyName: z
    .string({ required_error: "Name is required" })
    .min(3, "Name must be at least 3 character."),
  phone: z.string().nullish(),
  email: z.string({ required_error: "Email is required" }).email(),
  message: z.string({ required_error: "Message is required" }),
});

type FormType = z.infer<typeof formSchema>;

function Fund() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/fund", title: "for investor page" });
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormType>({
    resolver: zodResolver(formSchema),
  });

  useFacebookPageView();


  const onSubmit: SubmitHandler<FormType> = (data) => {
    axios
      .post(`${config.HOST}/insert_user.php`, {...data, page: 'fund'}, {headers: {
        'content-type': 'multipart/form-data'
      }})
      .then(() => {
        toast.success('Successfully submitted.')
      })
      .catch(() => {
        toast.error("Failed to send.");
      });
  };

  const [infoVisible, setInfoVisible] = useState(false);

  const toggleInfo = () => {
    setInfoVisible(!infoVisible);
  };

  return (
    <motion.main
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >

    <Seo
      title="Be a Rouser - Go Fund Yourself"
      description="More info for investors"
      url="https://therouseco.com/fund"
      keywords={["Rouse, drink, rehydration, sex, F*** It, investors, fund, market"]}
      uploadDate="2025-07-09"
      includeVideoSchema={false}
    />

      <section className="section-form" style={{ paddingTop: "30px" }}>
        <div className="form-div">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              className="heading-primary subheading"
              style={{ padding: "60px 0px", width: "100%"}}
            >
              Investment Opportunities{" "}
              <div style={{display: 'flex', justifyContent: "space-between", marginTop: "30px"}}>
              <FontAwesomeIcon
                style={{
                  display: windowWidth < 600 ? "flex" : "none",
                  marginLeft: "auto",
                  marginRight: "0",
                }}
                onClick={toggleInfo}
                icon={faInfoCircle}
              />

              </div>
            </div>
            <InfoPopup
              visible={infoVisible}
              info={
                <>
                  <p>
                    We don’t need life support.
                    We need a megaphone.
                  </p>
<br />
                  <p>
                    The product’s ready.
                    The movement’s real.
                    Let’s make some serious noise.
                  </p>
<br />
                  <p>
                    <strong>
                      Go
                      <br />
                      Fund
                      <br />
                      Yourself.
                    </strong>
                  </p>
<br />
                  <p>
                    If you’ve got bold instincts, a sharp eye for what’s next,
                    and the good sense to back the first drink that dares to say F*** it —
                    then fill out the form.
                  </p>
<br />
                  <p>
                    We’re not chasing hype.
                    We’re building a category.
                    <br />
                    <br />
                    And we’ll reach out if it clicks within 2 business days.
                    <br />
                    <br />
                    No pitch decks attached.
                    Ask, and we’ll show you something big... numbers of corse 
                  </p>
                </>
              }
              onClose={() => {
                setInfoVisible(false);
              }}
            />
            <div className="input-group">
              YOUR NAME*
              <input type="text" {...register("name")}></input>
              {errors.name && <p> {errors.name?.message}</p>}
            </div>
            <div className="input-group">
              COMPANY NAME*
              <input type="text" {...register("companyName")}></input>
              {errors.companyName && <p> {errors.companyName?.message}</p>}
            </div>
            <div className="input-group">
              PHONE NUMBER
              <input type="phone" {...register("phone")}></input>
              {errors.phone && <p> {errors.phone?.message}</p>}
            </div>
            <div className="input-group">
              EMAIL ADDRESS*
              <input type="email" {...register("email")}></input>
              {errors.email && <p> {errors.email?.message}</p>}
            </div>
            <div className="input-group">
              MESSAGE
              <textarea
                className="multiline"
                style={{ minHeight: "100px" }}
                {...register("message")}
              ></textarea>
              {errors.email && <p> {errors.email?.message}</p>}
            </div>
            <input
              type="submit"
              style={{ marginTop: "70px" }}
              value="Submit"
            ></input>
          </form>
          <div
            className="form-text info-text small-text"
            style={{ color: "white" }}
          >
            <div
              className="heading-primary subheading drawn"
              style={{
                padding: "60px 40px",
                color: "white",
                marginTop: "20px",
                width: "100%",
                display: "flex",
                justifyContent: "center"
              }}
            >
              Fund the market


            </div>
<div className="">

    <p>
      We don’t need life support. We need a megaphone.
    </p>
<br />
    <p>
      The product’s ready. The movement’s real. Let’s make some serious noise.
    </p>
<br />
    <p>
      <strong>
        Go
        <br />
        Fund
        <br />
        Yourself.
      </strong>
    </p>
<br />
    <p>
      If you’ve got bold instincts, a sharp eye for what’s next,
      and the good sense to back the first drink that dares to say F*** it —
      then fill out the form.
    </p>
<br />
    <p>
      We’re not chasing hype.
      We’re building a category.
      <br />
      And we’ll reach out if it clicks within 2 business days.
      <br />
      No pitch decks attached. Ask, and we’ll show you something big... numbers of corse 
    </p>
</div>
          </div>
        </div>
      </section>
    </motion.main>
  );
}

export default Fund;
